import { Navigate } from 'react-router-dom';
import { isAuthenticated, refreshAccessToken } from '../utils/auth';
import { useState, useEffect } from 'react';

interface ProtectedRouteProps {
    children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
    const [isAuth, setIsAuth] = useState(isAuthenticated());
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        const checkAuth = async () => {
            if (!isAuthenticated()) {
                const refreshed = await refreshAccessToken();
                if (refreshed) {
                    setIsAuth(true);
                } else {
                    setIsAuth(false);
                }
            } else {
                setIsAuth(true);
            }
            setIsLoading(false);
        };

        checkAuth();
    }, []);

    if (isLoading) {
        return <div>Loading...</div>; // Or a spinner
    }

    if (!isAuth) {
        // Redirect to LoginRequiredPage if not authenticated
        return <Navigate to="/login-required" replace />;
    }

    return <>{children}</>;
};

export default ProtectedRoute;